//#region src/bite_porter_application.ts
var BitePorterApplication = /* @__PURE__ */ function(BitePorterApplication) {
	BitePorterApplication["BureauProd"] = "bureau";
	BitePorterApplication["BureauSandbox"] = "bureau-sandbox";
	BitePorterApplication["BureauStaging"] = "bureau-staging";
	BitePorterApplication["ClockProd"] = "clock";
	BitePorterApplication["ClockSandbox"] = "clock-sandbox";
	BitePorterApplication["ClockStaging"] = "clock-staging";
	BitePorterApplication["EclairSandbox"] = "eclair-sandbox";
	BitePorterApplication["EclairStaging"] = "eclair-staging";
	BitePorterApplication["FlashProd"] = "flash";
	BitePorterApplication["FlashSandbox"] = "flash-sandbox";
	BitePorterApplication["FlashStaging"] = "flash-staging";
	BitePorterApplication["GarconProd"] = "garcon";
	BitePorterApplication["GarconSandbox"] = "garcon-sandbox";
	BitePorterApplication["GarconStaging"] = "garcon-staging";
	BitePorterApplication["MaitredProd"] = "maitred";
	BitePorterApplication["MaitredSandbox"] = "maitred-sandbox";
	BitePorterApplication["MaitredStaging"] = "maitred-staging";
	BitePorterApplication["McpAppProd"] = "mcp-app";
	BitePorterApplication["McpAppSandbox"] = "mcp-app-sandbox";
	BitePorterApplication["McpAppStaging"] = "mcp-app-staging";
	BitePorterApplication["OrderProcessorProd"] = "order-processor";
	BitePorterApplication["OrderProcessorSandbox"] = "order-processor-sandbox";
	BitePorterApplication["OrderProcessorStaging"] = "order-processor-staging";
	BitePorterApplication["VitrineProd"] = "vitrine";
	BitePorterApplication["VitrineSandbox"] = "vitrine-sandbox";
	BitePorterApplication["VitrineStaging"] = "vitrine-staging";
	BitePorterApplication["WebhookReceiverProd"] = "webhook-receiver";
	BitePorterApplication["WebhookReceiverSandbox"] = "webhook-receiver-sandbox";
	BitePorterApplication["WebhookReceiverStaging"] = "webhook-receiver-staging";
	BitePorterApplication["RecommendationAppProd"] = "recommendation";
	BitePorterApplication["RecommendationAppStaging"] = "recommendation-staging";
	BitePorterApplication["RecommendationAppSandbox"] = "recommendation-sandbox";
	return BitePorterApplication;
}(BitePorterApplication || {});
//#endregion
export { BitePorterApplication };

//# sourceMappingURL=bite_porter_application.js.map